import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import {AuthenticationService} from '../../shared/services/authentication.service';
import {APPLICATION_ROUTES_CONSTANTS} from '../constants/application-routes.constants';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authenticationService.loginStatus$.pipe(
      take(1),
      map((isLoggedIn) => {
        if (isLoggedIn) {
          return true;
        }

        this.router.navigate(['/' + APPLICATION_ROUTES_CONSTANTS.ROUTES.AUTHENTICATION.LOGIN], { queryParams: { returnUrl: state.url } });
        return false;
      })
    );
  }
}
